import { Grid, IconButton, makeStyles, Typography } from '@material-ui/core';
import { ExpandLess, ExpandMore, Input as InputIcon } from '@material-ui/icons';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';
import { modalClose } from 'modules/modal/actions';
import {
  InstancesWithSessionTimeoutFields,
  InstanceWithSessionTimeoutResultsFields,
} from 'modules/monitor/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import ApplicationState from 'store/interfaces';
import { getFlavorDisplayName } from 'utils/flavorDisplay';
import styles from './styles';

const useStyles = makeStyles(styles);

interface InstancesWithSessionTimeoutTableProps {
  isLoading: boolean;
  instancesWithSessionTimeout: InstancesWithSessionTimeoutFields;
  modalClose: () => void;
}
const InstancesWithSessionTimeoutTable = ({
  isLoading,
  instancesWithSessionTimeout,
  modalClose,
}: InstancesWithSessionTimeoutTableProps) => {
  const classes = useStyles();
  const history = useHistory();

  const [collapseTable, setCollapseTable] = React.useState(true);

  const headers = [
    {
      key: '',
      i18n: i18n.t('ACCESS_KEY'),
      centerTitle: true,
    },
    {
      key: 'instance_id',
      i18n: i18n.t('INSTANCE_ID_KEY'),
      order: false,
    },
    {
      key: 'partner',
      i18n: i18n.t('MONITOR.PARTNER_NAME'),
      order: false,
    },
    {
      key: 'environment',
      i18n: i18n.t('MONITOR.ENVIRONMENT_NAME'),
      order: false,
    },
    {
      key: 'flavor',
      i18n: i18n.t('MONITOR.FLAVOR'),
      order: false,
    },
  ];

  const redirectToInstance = (
    item: InstanceWithSessionTimeoutResultsFields
  ) => {
    history.push(
      `/environments/${item?.environment?.uuid}/instances?id=${item?.instance_id}`
    );
  };

  return (
    <Grid className={classes.table}>
      <Grid
        className={classes.titleBackground}
        onClick={() => setCollapseTable(!collapseTable)}
      >
        <Typography className={classes.tableTitle}>
          {i18n.t('MONITOR.INSTANCES_WITH_SESSION_TIMEOUT_TITLE')}
          {collapseTable ? <ExpandLess /> : <ExpandMore />}
        </Typography>
      </Grid>

      {collapseTable && (
        <TableItems
          header={
            <>
              {headers.map(item => (
                <TableCell key={item?.key} centerTitle={item?.centerTitle}>
                  {item?.i18n}
                </TableCell>
              ))}
            </>
          }
          renderItems={(item: InstanceWithSessionTimeoutResultsFields) => (
            <TableRow key={item.instance_id}>
              <TableCell centerTitle textAlignCenter>
                <IconButton
                  className={classes.accessButton}
                  onClick={() => {
                    redirectToInstance(item);
                    modalClose();
                  }}
                >
                  <InputIcon />
                </IconButton>
              </TableCell>
              <TableCell
                className={classes.text}
                ellipsis
                copyable
                maxLength={20}
                tooltip={item?.instance_id}
              >
                {item?.instance_id}
              </TableCell>
              <TableCell className={classes.text} tooltip={item?.partner.name}>
                {item?.partner.name}
              </TableCell>
              <TableCell
                className={classes.text}
                tooltip={item?.environment.name}
              >
                {item?.environment.name}
              </TableCell>
              <TableCell>{getFlavorDisplayName(item?.flavor)}</TableCell>
            </TableRow>
          )}
          data={instancesWithSessionTimeout}
          isLoading={isLoading}
          notFooter
          notFoundText={
            <Typography className={classes.notFoundText}>
              {i18n.t('MONITOR.NO_RESULTS_INSTANCES')}
            </Typography>
          }
        />
      )}
    </Grid>
  );
};

const mapStateToProps = ({
  monitor: { instancesWithSessionTimeout, isLoading },
}: ApplicationState) => ({
  instancesWithSessionTimeout,
  isLoading,
});

const mapDispatchToProps = {
  modalClose,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstancesWithSessionTimeoutTable);
